import request from '@/utils/request'

// 查询企业生产装置列表
export function listProductionDeviceZone(query) {
  return request({
    url: 'admin/data/productionDeviceZone/list',
    method: 'post',
    data: query
  })
}

// 查询企业生产装置详细
export function getProductionDeviceZone(id) {
  return request({
    url: 'admin/data/productionDeviceZone/' + id,
    method: 'get'
  })
}

// 新增企业生产装置
export function addProductionDeviceZone(data) {
  return request({
    url: 'admin/data/productionDeviceZone',
    method: 'post',
    data: data
  })
}

// 修改企业生产装置
export function updateProductionDeviceZone(data) {
  return request({
    url: 'admin/data/productionDeviceZone',
    method: 'put',
    data: data
  })
}

// 删除企业生产装置
export function delProductionDeviceZone(id) {
  return request({
    url: 'admin/data/productionDeviceZone/' + id,
    method: 'delete'
  })
}
// 查询企业生产装置列表
export function listProductionDeviceZoneList(query) {
  return request({
    url: 'admin/data/productionDeviceZone/queryList',
    method: 'post',
    data: query
  })
}

// 新增设备定时任务
export function productTasksAddItem(query) {
  return request({
    url: 'admin/data/productTasks/addItem',
    method: 'post',
    data: query
  })
}

// 设备定时任务
export function productTasksList(query) {
  return request({
    url: 'admin/data/productTasks/list',
    method: 'post',
    data: query
  })
}

// 设备定时任务
export function productTasksDeleteIds(query) {
  return request({
    url: 'admin/data/productTasks/deleteIds',
    method: 'post',
    data: query
  })
}